/* Maison Ella — busca e coleções: sugestões, filtros, ordenação e "View all".
 * Os grupos e as opções são montados a partir dos produtos que estão na
 * página, por isso mudam sozinhos conforme a categoria aberta. */
(function () {
  'use strict';

  var root = document.querySelector('[data-pdpb-search]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var term = root.dataset.term || '';
  var initial = parseInt(root.dataset.initial, 10) || 6;
  var searchUrl = (window.theme && window.theme.routes && window.theme.routes.search_url) || '/search';

  /* ── Sugestões (Shopify predictive search: queries) ── */
  var sugBox = root.querySelector('[data-suggestions]');
  if (term && sugBox) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources%5Btype%5D=query&resources%5Blimit%5D=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var list = (((data || {}).resources || {}).results || {}).queries || [];
        var norm = term.trim().toLowerCase();
        list = list.filter(function (q) { return q.text.trim().toLowerCase() !== norm; }).slice(0, 5);
        if (!list.length) return;
        var ul = sugBox.querySelector('[data-suggestions-list]');
        list.forEach(function (q) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = searchUrl + '?q=' + encodeURIComponent(q.text) + '&options%5Bprefix%5D=last';
          a.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="m15.5 15.5 5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
          var span = document.createElement('span');
          span.textContent = q.text.charAt(0).toUpperCase() + q.text.slice(1);
          a.appendChild(span);
          li.appendChild(a);
          ul.appendChild(li);
        });
        sugBox.hidden = false;
      })
      .catch(function () {});
  }

  var results = root.querySelector('[data-results]');
  if (!results) return;

  var grid = results.querySelector('[data-grid]');
  var items = Array.prototype.slice.call(grid.querySelectorAll('[data-search-item]'));
  var viewAll = results.querySelector('[data-view-all]');
  var counts = results.querySelectorAll('[data-visible-count]');
  var emptyMsg = results.querySelector('[data-empty-filter]');
  var panel = results.querySelector('[data-filters]');
  var groupNav = results.querySelector('[data-group-nav]');
  var activeCount = results.querySelector('[data-active-count]');
  var clearBtns = Array.prototype.slice.call(results.querySelectorAll('[data-reset]'));
  var expanded = false;

  /* ── Nomes e amostras de cor ── */
  var LABELS = {
    gold: 'Gold', silver: 'Silver', multicolor: 'Multicolour', chocolate: 'Chocolate', beige: 'Beige',
    SS: 'Stainless steel', '316': 'Stainless steel', '925': 'Sterling silver', Brass: 'Brass',
    HUGGIES: 'Huggies', pearl: 'Pearl', Stones: 'Other stones', Moissanite: 'Moissanite',
    new: 'New in', best: 'Best sellers'
  };
  var SWATCH = {
    gold: 'radial-gradient(circle at 35% 30%, #f7e08a 0%, #e0b93f 45%, #b8892a 100%)',
    silver: 'radial-gradient(circle at 35% 30%, #f4f4f4 0%, #c9c9c9 45%, #9b9b9b 100%)',
    SS: 'radial-gradient(circle at 35% 30%, #eceff0 0%, #b9c0c2 45%, #878e90 100%)',
    '316': 'radial-gradient(circle at 35% 30%, #eceff0 0%, #b9c0c2 45%, #878e90 100%)',
    '925': 'radial-gradient(circle at 35% 30%, #fafafa 0%, #d8d8d8 45%, #a8a8a8 100%)',
    Brass: 'radial-gradient(circle at 35% 30%, #f0d49a 0%, #c9a24a 45%, #94702a 100%)'
  };

  function label(v) { return LABELS[v] || v.charAt(0).toUpperCase() + v.slice(1); }

  function valuesOf(attr) {
    var out = [];
    items.forEach(function (el) {
      (el.dataset[attr] || '').split('|').forEach(function (v) {
        v = v.trim();
        if (v && out.indexOf(v) === -1) out.push(v);
      });
    });
    return out.sort(function (a, b) { return label(a).localeCompare(label(b)); });
  }

  function option(name, value, text, swatch) {
    var l = document.createElement('label');
    l.className = 'pdpb-filters__option';
    var input = document.createElement('input');
    input.type = 'checkbox';
    input.name = name;
    input.value = value;
    l.appendChild(input);
    if (swatch) {
      var dot = document.createElement('span');
      dot.className = 'pdpb-filters__swatch';
      dot.style.background = swatch;
      l.appendChild(dot);
    }
    var span = document.createElement('span');
    span.className = 'pdpb-filters__option-label';
    span.textContent = text;
    l.appendChild(span);
    return l;
  }

  function fillGroup(name, values, withSwatch) {
    var box = results.querySelector('[data-chips="' + name + '"]');
    var group = results.querySelector('[data-filter-group="' + name + '"]');
    if (!box || !group || values.length < 2) return false;
    values.forEach(function (v) { box.appendChild(option(name, v, label(v), withSwatch ? SWATCH[v] : null)); });
    group.hidden = false;
    return true;
  }

  fillGroup('material', valuesOf('material'), true);
  fillGroup('style', valuesOf('style'));
  fillGroup('stones', valuesOf('stones'));

  var flags = [];
  if (items.some(function (el) { return el.dataset.new === 'true'; })) flags.push('new');
  if (items.some(function (el) { return el.dataset.best === 'true'; })) flags.push('best');
  if (flags.length > 0) {
    var cbox = results.querySelector('[data-chips="collection"]');
    flags.forEach(function (f) { cbox.appendChild(option('collection', f, label(f))); });
    results.querySelector('[data-filter-group="collection"]').hidden = false;
  }

  /* ── Grupos: coluna à esquerda no desktop, sanfona no telemóvel ── */
  var groups = Array.prototype.slice.call(results.querySelectorAll('.pdpb-filters__group:not([hidden])'));
  groups.forEach(function (g, i) {
    var title = g.querySelector('.pdpb-filters__group-title').textContent;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pdpb-filters__nav-item' + (i === 0 ? ' is-active' : '');
    btn.textContent = title;
    btn.addEventListener('click', function () {
      groupNav.querySelectorAll('.pdpb-filters__nav-item').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      groups.forEach(function (x) { x.classList.toggle('is-current', x === g); });
    });
    groupNav.appendChild(btn);
    g.classList.toggle('is-current', i === 0);

    var head = g.querySelector('[data-group-toggle]');
    head.addEventListener('click', function () {
      var open = g.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ── Abrir e fechar ── */
  function openFilters() {
    panel.hidden = false;
    document.documentElement.classList.add('pdpb-filters-open');
  }
  function closeFilters() {
    panel.hidden = true;
    document.documentElement.classList.remove('pdpb-filters-open');
  }
  results.querySelectorAll('[data-open-filters]').forEach(function (b) { b.addEventListener('click', openFilters); });
  results.querySelectorAll('[data-close-filters]').forEach(function (b) { b.addEventListener('click', closeFilters); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel && !panel.hidden) closeFilters(); });

  var sortPanel = results.querySelector('[data-panel="sort"]');
  var sortBtn = results.querySelector('[data-open-sort]');
  if (sortBtn) sortBtn.addEventListener('click', function () {
    sortPanel.hidden = !sortPanel.hidden;
    sortBtn.setAttribute('aria-expanded', sortPanel.hidden ? 'false' : 'true');
  });

  /* ── Filtrar e ordenar ── */
  function checked(name) {
    return Array.prototype.slice.call(results.querySelectorAll('input[name="' + name + '"]:checked')).map(function (i) { return i.value; });
  }

  function has(el, attr, sel) {
    if (!sel.length) return true;
    var vals = (el.dataset[attr] || '').split('|').map(function (v) { return v.trim(); });
    return sel.some(function (s) { return vals.indexOf(s) !== -1; });
  }

  function apply() {
    var materialSel = checked('material');
    var styleSel = checked('style');
    var stonesSel = checked('stones');
    var collectionSel = checked('collection');
    var priceRaw = checked('price');
    var priceSel = priceRaw.map(function (v) { return v.split('-').map(Number); });
    var sort = checked('sort')[0] || 'relevance';

    var sorted = items.slice().sort(function (a, b) {
      if (sort === 'price-asc') return a.dataset.price - b.dataset.price;
      if (sort === 'price-desc') return b.dataset.price - a.dataset.price;
      if (sort === 'title') return a.dataset.title.localeCompare(b.dataset.title);
      return a.dataset.index - b.dataset.index;
    });

    var matches = sorted.filter(function (el) {
      if (!has(el, 'material', materialSel)) return false;
      if (!has(el, 'style', styleSel)) return false;
      if (!has(el, 'stones', stonesSel)) return false;
      if (collectionSel.length) {
        var ok = collectionSel.some(function (f) { return el.dataset[f] === 'true'; });
        if (!ok) return false;
      }
      if (priceSel.length) {
        var p = Number(el.dataset.price);
        if (!priceSel.some(function (r) { return p >= r[0] && p < r[1]; })) return false;
      }
      return true;
    });

    sorted.forEach(function (el) { grid.appendChild(el); el.hidden = true; });
    matches.forEach(function (el, i) { el.hidden = !expanded && i >= initial; });

    counts.forEach(function (c) { c.textContent = matches.length; });
    if (emptyMsg) emptyMsg.hidden = matches.length > 0;
    if (viewAll) {
      viewAll.hidden = expanded || matches.length <= initial;
      var total = viewAll.querySelector('[data-total]');
      if (total) total.textContent = matches.length;
    }

    var n = materialSel.length + styleSel.length + stonesSel.length + collectionSel.length + priceRaw.length;
    if (activeCount) {
      activeCount.textContent = n;
      activeCount.hidden = n === 0;
    }
    clearBtns.forEach(function (b) { if (b.classList.contains('pdpb-search__reset')) b.hidden = n === 0; });
  }

  results.addEventListener('change', function (e) {
    if (e.target.matches('input')) apply();
  });

  clearBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      results.querySelectorAll('.pdpb-filters input[type="checkbox"]').forEach(function (i) { i.checked = false; });
      apply();
    });
  });

  if (viewAll) viewAll.addEventListener('click', function () {
    expanded = true;
    apply();
  });

  apply();
})();
